"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconMessage', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M1 2C1 1.44772 1.44772 1 2 1H14C14.5523 1 15 1.44772 15 2V11C15 11.5523 14.5523 12 14 12H10.277L5.5145 14.8575C5.20556 15.0429 4.82081 15.0477 4.5073 14.8702C4.19379 14.6927 4 14.3603 4 14V12H2C1.44772 12 1 11.5523 1 11V2ZM3 3V10H5C5.55228 10 6 10.4477 6 11V12.2338L9.4855 10.1425C9.64092 10.0493 9.81876 10 10 10H13V3H3Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M1 2C1 1.44772 1.44772 1 2 1H18C18.5523 1 19 1.44772 19 2V14C19 14.5523 18.5523 15 18 15H12.3028L6.5547 18.8321C6.24784 19.0366 5.8533 19.0557 5.52814 18.8817C5.20298 18.7077 5 18.3688 5 18V15H2C1.44772 15 1 14.5523 1 14V2ZM3 3V13H6C6.55228 13 7 13.4477 7 14V16.1315L11.4453 13.1679C11.6096 13.0584 11.8026 13 12 13H17V3H3Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M1.03003 2C1.03003 1.44772 1.47774 1 2.03003 1H22.03C22.5823 1 23.03 1.44772 23.03 2V17C23.03 17.5523 22.5823 18 22.03 18H14.3168L6.56003 22.848C6.25176 23.0407 5.86322 23.0509 5.54526 22.8746C5.22731 22.6984 5.03003 22.3635 5.03003 22L5.03003 18H2.03003C1.47774 18 1.03003 17.5523 1.03003 17V2ZM3.03003 3V16H6.03003C6.58231 16 7.03003 16.4477 7.03003 17L7.03003 20.1958L13.5 16.152C13.659 16.0527 13.8426 16 14.03 16H21.03V3H3.03003Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M2 3.5C2 2.67157 2.67157 2 3.5 2H28.5C29.3284 2 30 2.67157 30 3.5V22.5C30 23.3284 29.3284 24 28.5 24H18.9542L10.3321 29.7481C9.87177 30.0549 9.27995 30.0835 8.79221 29.8225C8.30448 29.5615 8 29.0532 8 28.5V24H3.5C2.67157 24 2 23.3284 2 22.5V3.5ZM5 5V21H9.5C10.3284 21 11 21.6716 11 22.5V25.6972L17.6679 21.2519C17.9144 21.0877 18.2039 21 18.5 21H27V5H5Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;